import script from "./BannerSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerSlider.vue?vue&type=script&setup=true&lang=js"

import "./BannerSlider.vue?vue&type=style&index=0&id=1376cf66&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1376cf66"]])

export default __exports__